import { Feature } from '../../models/Feature'
import { apiClient } from '../../modules/apiclient'
import { PocketComponent, PocketComponentProps, usePSComponent } from '../PocketComponent'
import { FullScreenVideoModal } from '../app/FullScreenVideoModal'

type Props = {
    feature?: Feature
    featureID?: string
    title?: string
    text?: string
    onClose: () => void
}

type TutorialVideoModalData = {
    videoURL: string
    title: string
    text: string
    onClose: () => void
}

const viewWillAppear = async (base: PocketComponent) => {
    const props = base.props as Props
    const data = {
        videoURL: '',
        title: props.title ?? props.feature?.name ?? 'PocketSuite',
        text: props.text ?? props.feature?.pitch ?? '',
        onClose: props.onClose,
    }
    const id = props.featureID ?? props.feature?.tutorial ?? 'overview'
    try {
        const results = await apiClient.get<{ video_id: string }>(`/tutorial/${id}`)
        const json = results.data
        data.videoURL = `https://player.vimeo.com/video/${json.video_id}`
    }
    catch (e: any) {
        base.logAndDisplayError(e)
    }
    return data
}

const render = ({ data, base }: PocketComponentProps<TutorialVideoModalData>) => {
    return (
        <FullScreenVideoModal
            title={data.title}
            url={data.videoURL}
            isOpen={true}
            description={data.text}
            onClose={data.onClose}
        />
    )
}

export const TutorialVideoModal = usePSComponent(render, viewWillAppear)
